
























































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'

@Component

export default class ComponentAmericasmedicalcityExamesIntraOperatorios extends Vue {
  get getSolicitacaoStore() {
    const solicitacao = getModule(SolicitacaoStore, this.$store)
    return solicitacao
  }

  get getErrorMessage() {
    return this.getSolicitacaoStore.errorMessage
  }

  clearEquipeMedicaHospital() {
    if (this.getSolicitacaoStore.solicitacao.examesIntraOperatorios
      && !this.getSolicitacaoStore
        .solicitacao.examesIntraOperatorios.ultrassonografiaIntraoperatoria) {
      this.getSolicitacaoStore.solicitacao
        .examesIntraOperatorios.ultrassonografiaIntraoperatoriaEquipeDoHospital = null
    }
  }
}
